module.exports = __webpack_public_path__ + "static/media/Platinum.1899f576.png";